import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=12010448&scoped=true&"
import script from "./MainNavbar.vue?vue&type=script&lang=ts&"
export * from "./MainNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=12010448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12010448",
  null
  
)

export default component.exports